var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jk-events-listing__form"},[_c('search-form'),_c('search-results'),_c('pagination')],1)}
var staticRenderFns = []

export { render, staticRenderFns }